/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategorySummary
 */
export interface CategorySummary {
    /**
     * 
     * @type {string}
     * @memberof CategorySummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySummary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySummary
     */
    gender?: string;
    /**
     * 
     * @type {Date}
     * @memberof CategorySummary
     */
    birthDateMin?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CategorySummary
     */
    birthDateMax?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CategorySummary
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof CategorySummary
     */
    minPlayers?: number;
    /**
     * 
     * @type {number}
     * @memberof CategorySummary
     */
    maxPlayers?: number;
}

/**
 * Check if a given object implements the CategorySummary interface.
 */
export function instanceOfCategorySummary(value: object): value is CategorySummary {
    return true;
}

export function CategorySummaryFromJSON(json: any): CategorySummary {
    return CategorySummaryFromJSONTyped(json, false);
}

export function CategorySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategorySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthDateMin': json['birthDateMin'] == null ? undefined : (new Date(json['birthDateMin'])),
        'birthDateMax': json['birthDateMax'] == null ? undefined : (new Date(json['birthDateMax'])),
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'minPlayers': json['minPlayers'] == null ? undefined : json['minPlayers'],
        'maxPlayers': json['maxPlayers'] == null ? undefined : json['maxPlayers'],
    };
}

export function CategorySummaryToJSON(json: any): CategorySummary {
    return CategorySummaryToJSONTyped(json, false);
}

export function CategorySummaryToJSONTyped(value?: CategorySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'gender': value['gender'],
        'birthDateMin': value['birthDateMin'] == null ? value['birthDateMin'] : value['birthDateMin'].toISOString().substring(0,10),
        'birthDateMax': value['birthDateMax'] == null ? value['birthDateMax'] : value['birthDateMax'].toISOString().substring(0,10),
        'maxTeams': value['maxTeams'],
        'minPlayers': value['minPlayers'],
        'maxPlayers': value['maxPlayers'],
    };
}

